(function () {
    window.addEventListener('load', () => {
        /**
         * Nettoie les champs du formulaire dont l'identifiant est passé en paramètre.
         * @param nomFormulaire Le nom du formulaire.
         */
        function resetForm(nomFormulaire) {
            if (!nomFormulaire) {
                return;
            }
            const divForm = document.getElementById(nomFormulaire);
            const forms = divForm.querySelectorAll('form');
            forms.forEach(form => form.reset());
        }

        document.querySelectorAll('.js-reset-form').forEach(boutonAnnuler => {
            boutonAnnuler.addEventListener('click', () => resetForm(boutonAnnuler.getAttribute('commandFor')));
        });
    });
})();
